import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetListProfileUseCaseInterface } from 'domain/usecases';

export class RemoteGetListProfile implements GetListProfileUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetListProfileUseCaseInterface.Result>,
  ) {}

  async execute(
    params?: GetListProfileUseCaseInterface.Params,
  ): Promise<GetListProfileUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url + '/profiles/' + params?.id, {
        roleId: params?.roleId,
      }),
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
